import axios from "axios";
import { sisikong_url } from "../../../api";

// Types
export interface ChatRoomMember {
  username: string;
  email: string;
  first_name?: string | null;
  last_name?: string | null;
  role: "client" | "agent";
  source_entity: string;
}

export interface ChatRoom {
  source_entity: string;
  uid: string;
  name: string;
  description: string;
  room_code?: string | null;
  created_at: string;
  member_session_uids: string[];
  inactive_member_session_uids: string[];
}

export interface GetChatRoomsByEmailResponse extends Array<ChatRoom> {}

export interface GetChatRoomByRoomCodeResponse extends ChatRoom {}

// Helper functions
export function generateOfferChatRoomCode(offerReference: string): string {
  return `offer-chat-room___${offerReference}`;
}

export function generateQuotationChatRoomCode(quotationReference: string): string {
  return `quotation-request___${quotationReference}`;
}

// Axios request
export function getChatRoomsByEmail({
  email,
  token,
}: {
  email: string;
  token: string;
}): Promise<{ data: GetChatRoomsByEmailResponse }> {
  return axios.get(`${sisikong_url}/fastchat/api/v1/chat-rooms/by-email/${email}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export async function getChatRoomByRoomCode(
  room_code: string,
): Promise<{ data: GetChatRoomByRoomCodeResponse }> {
  const url = `${sisikong_url}/fastchat/api/v1/chat-rooms/by-room-code/${room_code}`;
  return await axios.get(url);
}
